module.exports = __webpack_public_path__ + "img/P150T_weapon_149.6616191c.png";